__turbopack_context__.v({
  "base": "close-button-module-scss-module__40MJAW__base",
  "circle": "close-button-module-scss-module__40MJAW__circle",
  "square": "close-button-module-scss-module__40MJAW__square",
});
